module.exports = __webpack_public_path__ + "static/img/1.5872d06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/1.png
// module id = m95c
// module chunks = 0